import TypeIcon from "@components/Location/TypeIcon";

export interface PlaceParams extends be.LocationPrediction {
  final: string;
  locations?: be.Location[];
}

function SearchMeta({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-center -mb-1 -mt-1">
      <div>
        <p className="m-0 text-gray-500 font-thin text-base">{title}</p>
      </div>
    </div>
  );
}

export function Place({
  final,
  title,
  description,
  source,
  type,
  typestring,
}: PlaceParams): JSX.Element {
  if (source == "searchMeta") {
    return <SearchMeta title={title} />;
  } else if (source == "title") {
    return (
      <div className="px-4 pt-2 mt-4">
        <div className="flex">
          <div className="text-base flex">
            <span className="font-bold text-lg grow hover:underline">{title}</span>
          </div>
        </div>
      </div>
    );
  } else if (source == "fixedHeader") {
    return (
      <div className="-mb-4">
        <span className="text-base font-bold">{title}</span>
      </div>
    );
  } else if (source == "universalLocation") {
    return (
      <div className={`relative flex items-center px-4 mt-1 mb-1 ${final == "true" ? "mb-4" : ""}`}>
        <TypeIcon typeKey={type} type={typestring} className="h-4 w-4 mr-4 flex-none" />
        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2">{title}</span>
            <span className=" whitespace-nowrap font-thin text-gray-600 text-sm">
              {description}
            </span>
          </p>
        </div>
      </div>
    );
  } else if (source == "fixedHudson") {
    return (
      <div className={`relative flex items-center py-2`}>
        <div className="bg-white rounded-xl mr-4 ">
          <TypeIcon typeKey={type} type={typestring} className="h-6 w-6 flex-none" />
        </div>

        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2 font-medium">{title}</span>
            <span className=" whitespace-nowrap font-thin  text-sm">{description}</span>
          </p>
        </div>
      </div>
    );
  } else if (source == "fixed") {
    return (
      <div className="py-1">
        <div className="flex">
          <div className="text-base flex items-center">
            <TypeIcon typeKey={type} type={typestring} className="h-4 w-4 mr-4 flex-none" />
            <span className="grow hover:underline ">{title}</span>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={`relative flex items-center px-4 mt-2 mb-3`}>
        <TypeIcon typeKey={type} type={type} className="h-6 w-6 mr-4 flex-none" />
        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2">{title}</span>
            <span className=" flex-wrap font-thin text-gray-600 text-sm">{description}</span>
          </p>
        </div>
      </div>
    );
  }
}
